import { selectFromRouteDto } from '../../models';
import RouteBreakdownSolutionQuery from './RouteBreakdownSolutionQuery';
import RouteBreakdownConstraintQuery from './RouteBreakdownConstraintQuery';

export default selectFromRouteDto()
  .isStarted
  .hexColor
  .tags(tag => tag.uuid.name)
  .constraints(RouteBreakdownConstraintQuery)
  .activeRouteSolution(RouteBreakdownSolutionQuery)
  .toString();
